/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { FieldGeneratorOutputType } from './FieldGeneratorOutputType.js';
import {
    FieldGeneratorOutputTypeFromJSON,
    FieldGeneratorOutputTypeFromJSONTyped,
    FieldGeneratorOutputTypeToJSON,
} from './FieldGeneratorOutputType.js';

/**
 * 
 * @export
 * @interface CreateGeneratorRequest
 */
export interface CreateGeneratorRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGeneratorRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGeneratorRequest
     */
    generatorKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGeneratorRequest
     */
    ignoredValues?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGeneratorRequest
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateGeneratorRequest
     */
    startContactEventId?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateGeneratorRequest
     */
    endContactEventId?: number;
    /**
     * 
     * @type {FieldGeneratorOutputType}
     * @memberof CreateGeneratorRequest
     */
    outputType?: FieldGeneratorOutputType;
    /**
     * 
     * @type {string}
     * @memberof CreateGeneratorRequest
     */
    outputValue?: string;
}

/**
 * Check if a given object implements the CreateGeneratorRequest interface.
 */
export function instanceOfCreateGeneratorRequest(value: object): boolean {
    return true;
}

export function CreateGeneratorRequestFromJSON(json: any): CreateGeneratorRequest {
    return CreateGeneratorRequestFromJSONTyped(json, false);
}

export function CreateGeneratorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGeneratorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'generatorKey': json['generatorKey'] == null ? undefined : json['generatorKey'],
        'ignoredValues': json['ignoredValues'] == null ? undefined : json['ignoredValues'],
        'label': json['label'] == null ? undefined : json['label'],
        'startContactEventId': json['startContactEventId'] == null ? undefined : json['startContactEventId'],
        'endContactEventId': json['endContactEventId'] == null ? undefined : json['endContactEventId'],
        'outputType': json['outputType'] == null ? undefined : FieldGeneratorOutputTypeFromJSON(json['outputType']),
        'outputValue': json['outputValue'] == null ? undefined : json['outputValue'],
    };
}

export function CreateGeneratorRequestToJSON(value?: CreateGeneratorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'description': value['description'],
        'generatorKey': value['generatorKey'],
        'ignoredValues': value['ignoredValues'],
        'label': value['label'],
        'startContactEventId': value['startContactEventId'],
        'endContactEventId': value['endContactEventId'],
        'outputType': FieldGeneratorOutputTypeToJSON(value['outputType']),
        'outputValue': value['outputValue'],
    };
}

